const loggedValues = new Set();

/**
 * Debug function to log a message only once. Highlighted in console with blue background
 * Useful for debugging and logging messages that are not supposed to be repeated
 * @param message message to log
 */
export const logOnlyOnce = (message: string) => {
  if (!loggedValues.has(message)) {
    console.log(`%c${message}`, 'color: white; background-color: blue; font-size: 16px; padding: 4px; border-radius: 4px;');
    loggedValues.add(message);
  }
};
